import { createContext } from 'react'

export const forgotContext = createContext({
    email: "",
    setEmail: ()=> {},
    code: "",
    setCode: ()=> {},
})